import patients from '../../../../../../../../services/patients/index';
import XlsxPopulate from 'xlsx-populate/browser/xlsx-populate';
import { from24To12 } from '../../../../../../../../services/utilities';

const setStyles = (cell, value) => {
    cell.value(value);

    cell.style("border", true);

    cell.style("fontSize", 20);

    cell.style("borderColor", "737373");

    cell.style("borderStyle", "thick");
}

const download = async (workbook) => {
    let blob = await workbook.outputAsync();

    var url = window.URL.createObjectURL(blob);
    var a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = "sitas.xlsx";
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
}

const createPage = async (workbook, chairs, sheetName, number, diagnostics) => {
    let sheet = workbook.sheet(sheetName);
    let chair = chairs[number - 1]

    setStyles(sheet.cell("A1"), "Nombre del cliente: ");
    setStyles(sheet.cell("B1"), "Teléfono del cliente: ");
    setStyles(sheet.cell("C1"), "Servicio: ");
    setStyles(sheet.cell("D1"), "Hora: ");

    let ids = chair.map(chair => {
        return {_id: chair.patient}
    })

    patients.find({$or: ids}, (err, people) => {
        chair.forEach((appointment, index) => {
            let i = index + 2;
            let patient = people.find((pat) => pat._id == appointment.patient)
            setStyles(sheet.cell("A"+i), patient.name + " " + patient.lastname);
            setStyles(sheet.cell("B"+i), patient.phone);
            setStyles(sheet.cell("D"+i), from24To12(appointment.time));
            if(appointment.old)
                setStyles(sheet.cell("C"+i), appointment.diagnostic);
            else {
                let diag = diagnostics.find((d) => d._id == appointment.diagnostic)
                setStyles(sheet.cell("C"+i), diag.name);
            }
        })

        if(number < 4){
            workbook.addSheet('Silla '+(number + 1));
            createPage(workbook, chairs, 'Silla '+(number + 1), number + 1, diagnostics)
        } else
            download(workbook)
    })
}

export const generateExcel = async (chair1, chair2, chair3, chair4, diagnostics) => {
    let workbook = await XlsxPopulate.fromBlankAsync();

    workbook.sheet(0).name("Silla 1");
    await createPage(workbook, [chair1, chair2, chair3, chair4], "Silla 1", 1, diagnostics);
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/home/scenes/pick-day/components/all-chairs/excel.js